<template>
  <div>
    <Head title="បុគ្គលិក" />
    <h1 class="moul flex mb-8 text-2xl"><UsersIcon class="mr-2 w-8 h-8" /> បុគ្គលិក</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">តួនាទី:</label>
        <select v-model="form.role" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="user">មន្ត្រីឥណទាន</option>
          <option value="owner">អ្នកគ្រប់គ្រង</option>
        </select>
        <label class="block mt-4 text-gray-700">ស្ថានភាព:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null">បង្ហាញតែបុគ្គលិកមិនបានលុប</option>
          <option value="with">ជាមួយបុគ្គលិកដែលបានលុប</option>
          <option value="only">បង្ហាញតែបុគ្គលិកដែលបានលុប</option>
        </select>
      </search-filter>
      <Link v-if="auth.user.owner" class="btn-indigo flex items-center" href="/users/create">
        <PlusIcon class="mr-1 w-4 h-4" />
        <span>បង្កើត</span>
        <span class="hidden md:inline">ថ្មី</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">ឈ្មោះ</th>
          <th class="pb-4 pt-6 px-6">លេខទូរសព្ទ</th>
          <th class="pb-4 pt-6 px-6" colspan="2">Role</th>
        </tr>
        <tr v-for="user in users" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/users/${user.id}/edit`">
              <img v-if="user.photo" class="block -my-2 mr-2 w-5 h-5 rounded-full" :src="user.photo" />
              {{ user.name }}
              <icon v-if="user.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/users/${user.id}/edit`" tabindex="-1">
              {{ user.phone }}
            </Link>
          </td>
          <!-- <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/users/${user.id}/edit`" tabindex="-1">
              {{ user.email }}
            </Link>
          </td> -->
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/users/${user.id}/edit`" tabindex="-1">
              {{ user.owner ? 'អ្នកគ្រប់គ្រង' : 'មន្ត្រីឥណទាន' }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/users/${user.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="users.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">មិនមានបុគ្គលិកត្រូវបានបង្ហាញទេ!</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import { UsersIcon, PlusIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    PlusIcon,
    UsersIcon,
  },
  layout: Layout,
  props: {
    auth: Object,
    filters: Object,
    users: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        role: this.filters.role,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/users', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
